import React, { useState } from 'react';
import { Upload, message, Button, Card, Alert, Progress } from 'antd';
import { UploadOutlined, CheckCircleOutlined, ExclamationCircleOutlined } from '@ant-design/icons';

const BulkUploadSection = ({ title, handleBulkUpload, loading, error, uploadResult }) => {
  const [file, setFile] = useState(null);

  const handleUpload = async () => {
    if (!file) {
      message.error('Please select a file first!');
      return;
    }

    await handleBulkUpload(file);

    if (uploadResult && !error) {
      message.success(`Upload successful. Created: ${uploadResult.created}, Updated: ${uploadResult.updated}`);
    }

    if (error) {
      message.error(`Upload failed: ${error}`);
    }
  };

  const props = {
    onRemove: () => {
      setFile(null);
    },
    beforeUpload: (file) => {
      const isExcel = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' || 
                     file.type === 'application/vnd.ms-excel';
                    
      if (!isExcel) {
        message.error('You can only upload Excel files!');
        return Upload.LIST_IGNORE;
      }
      
      setFile(file);
      return false;
    },
    file,
  };

  return (
    <Card
      title={title}
      className="bulk-upload-card"
      bordered={false}
    >
      <div className="upload-area" style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        <div className="file-selector">
          <Upload {...props} maxCount={1}>
            <Button icon={<UploadOutlined />}>Select Excel File</Button>
          </Upload>
          {file && (
            <div className="file-info" style={{ marginTop: '8px', fontSize: '14px', color: '#666' }}>
              Selected file: {file.name} ({(file.size / 1024).toFixed(2)} KB)
            </div>
          )}
        </div>
        
        <Button
          type="primary"
          onClick={handleUpload}
          disabled={!file}
          loading={loading}
          block
        >
          {loading ? 'Uploading...' : 'Start Upload'}
        </Button>
        
        {loading && (
          <Progress percent={99} status="active" style={{ marginTop: '8px' }} />
        )}
        
        {error && (
          <Alert
            message="Upload Error"
            description={error}
            type="error"
            showIcon
            icon={<ExclamationCircleOutlined />}
          />
        )}
        
        {uploadResult && !error && (
          <Alert
            message="Upload Successful"
            description={
              <div>
                <p><strong>Created:</strong> {uploadResult.created} records</p>
                <p><strong>Updated:</strong> {uploadResult.updated} records</p>
                {uploadResult.errors && uploadResult.errors.length > 0 && (
                  <p><strong>Errors:</strong> {uploadResult.errors.length} records</p>
                )}
              </div>
            }
            type="success"
            showIcon
            icon={<CheckCircleOutlined />}
          />
        )}
      </div>
    </Card>
  );
};

export default BulkUploadSection;